<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="pestControlFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                pestControlFileForm: () => import('../forms/PestControlFileForm'),
                headers: [
                    { text: 'Pest Control', value: 'pestControlId', table: 'pestControls', form: () => import('../forms/PestControlForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    pestControls: [],
                    items: []
                },
                sorting: [
                    { column: "pestControlId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'pestControlFiles',
                editPageName: 'pestControlFile',
                apiMethod: 'PestControlFiles',
                claimName: 'PestControlFiles',
                formTitle: 'Pest Control File',
                excelTitle: 'Pest Control Files',
                hasEditPage: false,
            }
        },
    };
</script>
